<template>
    <a-row wrap
           justify="end"
           align="middle">

        <a-col>
            <a-button type="primary"
                      @click="add">新建类型</a-button>
        </a-col>
    </a-row>

    <a-spin :spinning="loadings"
            tip="正在为您加载">
        <a-row :gutter="[10, 10]"
               class="n-mt-2"
               style="min-height: 200px">
            <a-col :xs="24"
                   :sm="12"
                   :md="12"
                   :lg="8"
                   :xl="6"
                   :xxl="4"
                   v-for="(item, index) in datas"
                   :key="item.id">
                <div class="c-task-type n-bg-1 n-plr-2 n-ptb-2 n-radius-3"
                     style="{height: 117px;}">
                    <a-row align="middle"
                           justify="space-between">
                        <a-col flex="1"
                               class="n-e-1">{{item.taskTypeName}} </a-col>
                        <a-col flex="0 0 60px"
                               class="n-text-right">
                            <span class="n-bg-3 n-c-4 n-line-height-1-5 n-inline-block n-radius-3 n-plr-1"
                                  v-if="index == 0">默认</span>
                            <span class="n-bg-base n-c-1 n-line-height-1-5 n-inline-block n-radius-3 n-plr-1"
                                  v-else>自定义</span>
                        </a-col>
                    </a-row>
                    <a-row class="n-mt-3">
                        <a-col class="n-e-2"
                               style="height: 40px">{{item.label}}</a-col>
                    </a-row>
                    <a-row class="n-mt-3"
                           justify="end"
                           :gutter="5"
                           style="height: 25px">
                        <a-col class="n-e-2">
                            <a-button type="primary"
                                      size="small"
                                      @click="edit(item)"
                                      v-if="index != 0">编辑</a-button>
                        </a-col>
                        <a-col class="n-e-2">
                            <a-popconfirm title="确定删除吗"
                                          ok-text="删除"
                                          placement="leftTop"
                                          cancel-text="取消"
                                          @confirm="del(item)"
                                          v-if="index != 0">
                                <a-button type="primary"
                                          size="small"
                                          danger>删除</a-button>
                            </a-popconfirm>

                        </a-col>
                    </a-row>
                </div>
            </a-col>
        </a-row>
    </a-spin>

    <AddTaskTypeBox :visible="showAddTaskType"
                    ref="addTaskType"
                    @close="showAddTaskType = false"
                    @success="getTaskType"></AddTaskTypeBox>
</template>
<script >
    import { mapMutations, mapState } from 'vuex';
    import nui from '@/assets/script';

    import AddTaskTypeBox from '@/components/AddTaskTypeBox'

    export default {
        name: 'TaskType',
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                showAddTaskType: false,
                datas: [],
                loadings: false
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setWindowSize'])),

            NMounted () {
                this.getTaskType()
            },
            /**
             * @description 获取任务类型
             */
            getTaskType () {
                this.loadings = true;

                this.request(this.API.taskType).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.datas = res.data
                        this.loadings = false;
                    } else {
                        this.error(res.msg);
                    }
                })
            },
            add () {
                this.showAddTaskType = true;

                this.$nextTick(() => {
                    this.$refs.addTaskType.setData()
                })
            },
            /**
             * @description 编辑
             */
            edit (data) {
                this.showAddTaskType = true;

                this.$nextTick(() => {
                    this.$refs.addTaskType.setData(data.id)
                })
            },
            del (data) {
                this.request(this.API.deleteTaskType, {
                    method: 'post',
                    params: { taskTypeId: data.id }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.datas = this.datas.filter(item => item.id != data.id)
                    } else {
                        this.error(res.msg);
                    }
                })
            }
        }),
        components: {
            AddTaskTypeBox
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
</style>